/* eslint-disable max-len */
/* 
Stress / Pressure / Fatigue
{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]}, 

Distraction / Complacency / Lack of awareness
{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},

Lack of communication / teamwork / assertiveness
{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},

Lack of resources, lack of knowledge, norms
{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
*/


/*
Lack of Communication 
{type: 'dirtyDozen', dirtyDozenId: 1, value: 1},

Distraction 
{type: 'dirtyDozen', dirtyDozenId: 2, value: 1},

Lack of Resources 
{type: 'dirtyDozen', dirtyDozenId: 3, value: 1},

Stress 
{type: 'dirtyDozen', dirtyDozenId: 4, value: 1},

Complacency 
{type: 'dirtyDozen', dirtyDozenId: 5, value: 1},

Lack of Teamwork 
{type: 'dirtyDozen', dirtyDozenId: 6, value: 1},

Pressure 
{type: 'dirtyDozen', dirtyDozenId: 7, value: 1},

Lack of Awareness 
{type: 'dirtyDozen', dirtyDozenId: 8, value: 1},

Lack of Knowledge 
{type: 'dirtyDozen', dirtyDozenId: 9, value: 1},

Fatigue 
{type: 'dirtyDozen', dirtyDozenId: 10, value: 1},

Lack of Assertiveness 
{type: 'dirtyDozen', dirtyDozenId: 11, value: 1},

Norms 
{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},

*/

/*
{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
*/

let eventCardsData = {
	/* Day 1 */
	'day-1': [
		{
			id: 5,
			title: {
				en: 'The passenger seat',
				de: 'Der Passagiersitz',
				pt: 'O lugar do passageiro'
			},
			text: {
				en: 'You are asked to contact a captain who has reported a problem with a cabin seat reclining mechanism. A repair normally takes 25 minutes. The aircraft has been boarded at full capacity. No spare aircraft are available.',
				de: 'Sie werden gebeten, sich mit einem Kapitän in Verbindung zu setzen, der ein Problem mit dem Verstellmechanismus eines Kabinensitzes gemeldet hat. Eine Reparatur dauert normalerweise 25 Minuten. Das Flugzeug ist bereits voll besetzt. Es sind keine Ersatzflugzeuge verfügbar.',
				pt: 'Você foi solicitado a contatar um comandante que relatou um problema com o mecanismo de reclinação de uma poltrona da cabine. O reparo normalmente leva 25 minutos. A aeronave está com sua capacidade máxima de embarque atingida. Não há aeronaves reservas disponíveis.'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You replace the actuator straight away while the passengers wait in the aisle.',
						de: 'Sie tauschen den Aktuator sofort aus, während die Fahrgäste im Gang warten.',
						pt: 'Você substitui o atuador imediatamente enquanto os passageiros aguardam no corredor.'
					},
					consequences: {
						text: {
							en: 'Passengers may distract you and create pressure, so you may feel compelled to select a "quick fix".',
							de: 'Passagiere können Sie ablenken und unter Druck setzen, so dass Sie sich gezwungen fühlen, eine "schnelle Lösung" zu wählen.',
							pt: 'Os passageiros podem distraí-lo e criar pressão, fazendo com que você se sinta pressionado a escolher uma "solução rápida".'
						},
						effects: [
							{type: 'dirtyDozen', dirtyDozenId: 4, value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You ask the captain to send the passengers back to the terminal while you perform the repair job.',
						de: 'Sie bitten den Kapitän, die Passagiere zurück zum Terminal zu schicken, während Sie die Reparatur durchführen.',
						pt: 'Você pede ao Comandante que envie os passageiros de volta ao terminal enquanto realiza o reparo.'
					},
					consequences: {
						text: {
							en: 'This puts a lot of operational pressure on both aircraft and ground crew.',
							de: 'Dies stellt sowohl für die Flugzeugbesatzung als auch für das Bodenpersonal eine große Belastung dar.',
							pt: 'Isso gera muita pressão operacional tanto para o pessoal de voo quanto para a equipa de manutenção.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 7, value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You inform the captain that you will defer the defect in accordance with the Minimum Equipment List.',
						de: 'Sie teilen dem Kapitän mit, dass Sie den Mangel gemäß der Minimum Equipment List zurückstellen werden.',
						pt: 'Você informa ao Omandante que irá adiar a correção do defeito de acordo com a Lista de Equipamentos Mínimos.'
					},
					consequences: {
						text: {
							en: 'Some passengers must be off-loaded.',
							de: 'Einige Passagiere müssen das Flugzeug verlassen.',
							pt: 'Alguns passageiros precisam desembarcar.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 7, value: 1},
							{type: 'time', value: 2, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
			]
		},
		{
			id: 6,
			title: {
				en: 'The arm rest',
				de: 'Die Armlehne',
				pt: 'O apoio de braço'
			},
			text: {
				en: 'You are performing some maintenance tasks in the flight deck. On your way through the cabin, you notice an arm rest which has come completely detached from a passenger seat.',
				de: 'Sie führen einige Wartungsarbeiten in der Kabine durch. Auf Ihrem Weg durch die Kabine bemerken Sie eine Armlehne, die sich vollständig von einem Passagiersitz gelöst hat.',
				pt: 'Você está realizando algumas tarefas de manutenção na cabine de comando. Ao percorrer a cabine, você percebe um apoio de braço que se desprendeu completamente de um assento de passageiro.'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'There is no entry about this defect in the log. It is a simple 10-minutes job, so you add it to the work order you have, and carryout the job while you are in the area.',
						de: 'Es gibt keinen Eintrag über diesen Mangel im TechLog. Es handelt sich um einen einfachen 10-Minuten-Auftrag, den Sie in Ihren Arbeitsauftrag aufnehmen und ausführen, während Sie vor Ort sind.',
						pt: 'Você está realizando algumas tarefas de manutenção na cabine de comando. Ao percorrer a cabine, você percebe um apoio de braço que se desprendeu completamente de um assento de passageiro.'
					},
					consequences: {
						text: {
							en: 'A proactive action but maybe your time and skills were needed elsewhere.',
							de: 'Eine proaktive Maßnahme, aber vielleicht wurden Ihre Zeit und Ihre Fähigkeiten an anderer Stelle benötigt.',
							pt: 'Uma atitude proativa, mas talvez seu tempo e suas habilidades fossem necessários noutro lugar.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 2, value: 1},
							{type: 'time', value: 2, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'There is a procedure for flight and cabin crew to report defects. You ignore the problem and focus on your own tasks.',
						de: 'Es gibt ein Verfahren für das Flug- und Kabinenpersonal, um Mängel zu melden. Sie ignorieren das Problem und konzentrieren sich auf Ihre eigenen Aufgaben.',
						pt: `Existe um procedimento para que a tripulação de voo e de cabine relate defeitos. Você ignora o problema e se concentra em suas próprias tarefas.`
					},
					consequences: {
						text: {
							en: 'If unreported the defect may incur delays or reduced revenues from an inoperative seat.',
							de: 'Wird der Defekt nicht gemeldet, kann es zu Verspätungen oder Umsatzeinbußen durch einen nicht funktionierenden Sitz kommen.',
							pt: 'Caso não seja reportado, o defeito pode acarretar atrasos ou redução de receitas devido a um assento inoperante.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 5, value: 1},
							{type: 'cost', value: 2, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You talk to your supervisor right away and tell her about your discovery.',
						de: 'Sie sprechen sofort mit Ihrem Vorgesetzten und erzählen ihr von Ihrer Entdeckung.',
						pt: 'Você conversa imediatamente com sua supervisora ​​e conta-lhe sobre sua descoberta.'
					},
					consequences: {
						text: {
							en: 'You are distracted from your present task.',
							de: 'Sie sind von Ihrer aktuellen Aufgabe abgelenkt.',
							pt: 'Você está se distraindo da sua tarefa atual.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 2, value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]}, 
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		},
		{
			id: 7,
			title: {
				en: 'The towing',
				de: 'Der Schleppvorgang',
				pt: 'O Reboque'
			},
			text: {
				en: `You have been working on an aircraft sitting on the apron outside the hangar in order to get it ready for the morning schedule. Everybody else has left for the day. Company policy states 1) Towing an aircraft into the hangar requires two wing-walkers. 2) All aircraft shall be parked inside overnight to protect them from weather and increase morning departure dispatch reliability.
					<br /><br />You try to call Ground Handling but nobody picks up.`,
				de: `Sie haben an einem Flugzeug gearbeitet, das auf dem Vorfeld vor dem Hangar steht, um es auf den morgendlichen Flugplan vorzubereiten. Alle anderen sind für heute gegangen. Die Unternehmensrichtlinien besagen: 1) Für das Schleppen eines Flugzeugs in den Hangar sind zwei Wing-Walker erforderlich. 2) Alle Flugzeuge werden über Nacht drinnen geparkt, um sie vor Witterungseinflüssen zu schützen und die Zuverlässigkeit der Abfertigung am Morgen zu erhöhen.
					<br /><br />Sie versuchen, die Bodenabfertigung anzurufen, aber niemand nimmt ab.`,
				pt: `Você está atrabalhar numa aeronave estacionada no pátio, fora do hangar, para prepará-la para a programação da manhã. Todos os outros já foram embora. A política da empresa estabelece: 1) O reboque de uma aeronave para dentro do hangar requer dois auxiliares de solo. 2) Todas as aeronaves devem ser estacionadas dentro do hangar durante a noite para protegê-las das intempéries e aumentar a confiabilidade das partidas pela manhã.
					<br /><br />Você tenta ligar para o setor de serviços de solo, mas ninguém atende.`
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You write a sticky note with the text: “Handlers! Remember to put aircraft in hangar” and pin it to the door to the break room.',
						de: 'Sie schreiben einen Klebezettel mit dem Text: "Abfertiger! Denkt daran, die Flugzeuge in den Hangar zu bringen" und kleben ihn an die Tür zum Pausenraum.',
						pt: 'Você escreve um post-it com o texto: “Responsáveis ​​pela manutenção! Lembrem-se de colocar as aeronaves no hangar” e o fixa na porta da sala de descanso.'
					},
					consequences: {
						text: {
							en: 'If the staff do not see the note, the aircraft sits outside all night.',
							de: 'Wenn das Personal den Zettel nicht sieht, bleibt das Flugzeug die ganze Nacht draußen stehen.',
							pt: 'Se a equipa não vir o bilhete, a aeronave ficará estacionada ao relento a noite toda.'
						},
						effects: [
							{type: 'cost', value: 2},
							{type: 'dirtyDozen', dirtyDozenId: 1, value: 1},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'The aircraft cleaning company is in the hangar. You ask two of the cleaners to act as wing walkers when you tow the aircraft in.',
						de: 'Die Flugzeugreinigungsfirma befindet sich im Hangar. Sie bitten zwei der Reinigungskräfte, als "Wing Walker" zu fungieren, wenn Sie das Flugzeug einschleppen.',
						pt: 'A empresa de limpeza de aeronaves está no hangar. Você pede a dois dos funcionários da limpeza que atuem como sinalizadores de aproximação quando você rebocar a aeronave para dentro.'
					},
					consequences: {
						text: {
							en: 'Use of untrained staff may cause confusion and communication breakdown during critical phases of towing.',
							de: 'Der Einsatz von ungeschultem Personal kann in kritischen Phasen des Schleppvorgangs zu Verwirrung und Kommunikationsstörungen führen.',
							pt: 'A utilização de pessoal não treinado pode causar confusão e falhas de comunicação durante fases críticas do reboque.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},

						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'If the rules are impossible to comply with, you can do nothing. You leave the aircraft as it is and go home.',
						de: 'Wenn die Regeln nicht eingehalten werden können, können Sie nichts tun. Sie lassen das Flugzeug so, wie es ist, und gehen nach Hause.',
						pt: 'Se as regras forem impossíveis de cumprir, você não pode fazer nada. Você abandona a aeronave como está e volta para casa.'
					},
					consequences: {
						text: {
							en: 'Risk of delays in the morning rotation if the aircraft is exposed to inclement weather.',
							de: 'Wenn das Flugzeug schlechtem Wetter ausgesetzt ist, besteht die Gefahr von Verspätungen im morgendlichen Flugbetrieb.',
							pt: 'Risco de atrasos na rotação matinal se a aeronave estiver exposta a condições meteorológicas adversas.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 11, value: 1},
							{type: 'time', value: 2, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
			]
		},
		{
			id: 8,
			title: {
				en: 'The bolt',
				de: 'Der Bolzen',
				pt: 'O parafuso'
			},
			text: {
				en: 'You are installing a bolt in the hot section of an engine. The manual calls for the bolt to be lubricated with a special heat resistant compound. The only batch in the hangar is quarantined as it expired three weeks ago.',
				de: 'Sie bauen eine Schraube in die Hot Section eines Triebwerks ein. Laut Handbuch muss die Schraube mit einer speziellen hitzebeständigen Paste geschmiert werden. Die einzige Charge im Hangar liegt im Sperrlager, da sie vor drei Wochen abgelaufen ist.',
				pt: `Você está instalando um parafuso na seção quente de um motor. O manual recomenda que o parafuso seja lubrificado com um composto especial resistente ao calor. O único lote disponível no hangar está em quarentena, pois expirou há três semanas.`
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A',
					},
					text: {
						en: 'You retrieve it from quarantine and use it anyway as it looks satisfactory.',
						de: 'Sie holen die Charge aus dem Sperrlager und verwenden sie trotzdem, da sie zufriedenstellend aussieht.',
						pt: `Você o recupera da quarentena e o utiliza mesmo assim, pois parece estar em boas condições.`
					},
					consequences: {
						text: {
							en: 'Use of a product which doesn\'t conform to specifications can introduce an immediate or latent problem in the engine.',
							de: 'Die Verwendung eines Produkts, das nicht den Spezifikationen entspricht, kann ein unmittelbares oder latentes Problem im Triebwerk verursachen.',
							pt: `A utilização de um produto que não esteja em conformidade com as especificações pode causar problemas imediatos ou latentes no motor.`
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 5, value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},

						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B',
					},
					text: {
						en: 'This is the only engine you know of where this special compound is used. All other comparable installations use a more common compound. You use that one.',
						de: 'Dies ist das einzige Triebwerk, von dem Sie wissen, für das diese spezielle Mischung verwendet wird. Alle anderen vergleichbaren Einbauten verwenden eine gängigere Mixtur. Sie verwenden einfach diese.',
						pt: `Este é o único motor que você conhece que utiliza esse composto especial. Todas as outras instalações comparáveis ​​usam um composto mais comum. Você deve usar esse.`
					},
					consequences: {
						text: {
							en: 'Use of a product which doesn\'t conform to specifications can introduce an immediate or latent problem in the engine.',
							de: 'Die Verwendung eines Produkts, das nicht den Spezifikationen entspricht, kann ein unmittelbares oder latentes Problem im Triebwerk verursachen.',
							pt: `A utilização de um produto que não esteja em conformidade com as especificações pode causar problemas imediatos ou latentes no motor.`
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 9, value: 1},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C',
					},
					text: {
						en: 'You stop work and order a delivery of the special compound. It will arrive in fourteen days.',
						de: 'Sie stellen die Arbeit ein und bestellen eine Lieferung der Spezialpaste. Sie wird in vierzehn Tagen eintreffen.',
						pt: `Você interrompe o trabalho e solicita a entrega do composto especial. Ele chegará em quatorze dias.`
					},
					consequences: {
						text: {
							en: 'Lack of resources may cause increased down-time, cost and operational pressure.',
							de: 'Ein Mangel an Ressourcen kann zu längeren Ausfallzeiten, höheren Kosten und größerem Betriebsdruck führen.',
							pt: `A falta de recursos pode causar aumento do tempo de inatividade, dos custos e da pressão operacional.`
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 7, value: 1},
							{type: 'cost', value: 2, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		}
	],
	/* Day 2 */
	'day-2': [
		{
			id: 10,
			title: {
				en: 'The incorrect manual',
				de: 'Das fehlerhafte Handbuch',
				pt: 'O manual incorreto'
			},
			text: {
				en: 'You are on night shift carrying out a complex test according to the Maintenance Manual. However, the prescribed test procedures do not seem to quite fit the aircraft layout.',
				de: 'Sie sind in der Nachtschicht und führen einen komplexen Test gemäß dem Wartungshandbuch durch. Die vorgeschriebenen Prüfverfahren scheinen jedoch nicht ganz zum Luftfahrzeugtyp zu passen.',
				pt: `Você está no turno da noite realizando um teste complexo de acordo com o Manual de Manutenção. No entanto, os procedimentos de teste prescritos não parecem se adequar perfeitamente ao layout da aeronave.`
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A',
					},
					text: {
						en: 'Wait until the morning to get advice from the Quality Manager.',
						de: 'Sie warten bis zum Morgen, um den Rat des Qualitätsmanagers einzuholen.',
						pt: `Aguarde até a manhã seguinte para obter orientações do Gestor de Qualidade.`
					},
					consequences: {
						text: {
							en: 'Aircraft is delayed.',
							de: 'Das Flugzeug hat Verspätung.',
							pt: `A aeronave está atrasada`
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B',
					},
					text: {
						en: 'Tweak the test procedure so you are sure you will obtain the required result.',
						de: 'Sie optimieren das Testverfahren, so dass Sie sicher sein können, dass Sie das gewünschte Ergebnis erhalten.',
						pt: `Ajuste o procedimento de teste para garantir que você obterá o resultado desejado.`
					},
					consequences: {
						text: {
							en: 'You cannot be sure that the test was effective and adequate.',
							de: 'Sie können nicht sicher sein, dass der Test wirksam und angemessen war.',
							pt: `Não é possível ter certeza de que o teste foi eficaz e adequado.`
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 9, value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C',
					},
					text: {
						en: 'Do what the book says. Then raise a technical publication query.',
						de: 'Sie tun, was im Handbuch steht. Dann stellen Sie eine Anfrage zur technischen Veröffentlichung.',
						pt: `Faça o que o livro diz. Depois, faça uma consulta técnica sobre a publicação.`
					},
					consequences: {
						text: {
							en: 'You cannot be sure that the test was effective and adequate.',
							de: 'Sie können nicht sicher sein, dass der Test wirksam und angemessen war.',
							pt: `Não é possível ter certeza de que o teste foi eficaz e adequado.`
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 9, value: 1},
							{type: 'cost', value: 2, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		},
		{
			id: 11,
			title: {
				en: 'The double shift',
				de: 'Die Doppelschicht',
				pt: `O duplo turno`
			},
			text: {
				en: 'You have to work a double shift in order to finish an engine change. The last hours of the job involve running the engine, opening cowlings and making adjustments repeatedly. It is windy and cold and getting very late.',
				de: 'Sie müssen eine Doppelschicht einlegen, um einen Triebwerkstausch abzuschließen. Die letzten Stunden der Arbeit bestehen darin, wiederholt das Triebwerk laufen zu lassen, die Cowlings zu öffnen und Einstellungen vorzunehmen. Es ist windig, kalt und es wird sehr spät.',
				pt: `É preciso fazer um turno duplo para terminar a troca do motor. As últimas horas do trabalho envolvem ligar o motor, abrir as carenagens e fazer ajustes repetidamente. Está ventando, frio e já está ficando muito tarde.`
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You perform the work as fast as possible while the aircraft is on the apron.',
						de: 'Sie führen die Arbeiten so schnell wie möglich aus, während sich das Flugzeug auf dem Vorfeld befindet.',
						pt: `Você executa o trabalho o mais rápido possível enquanto a aeronave está no stand exterior.`
					},
					consequences: {
						text: {
							en: 'The rush to finish the job may lead you to forget important safety routines.',
							de: 'Die Arbeit in der Eile kann dazu führen, dass Sie wichtige Sicherheitsroutinen vergessen.',
							pt: `A pressa para terminar o trabalho pode levar você a esquecer importantes procedimentos de segurança.`
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 2, value: 1},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You tow the aircraft into the hangar each time you do adjustments.',
						de: 'Sie schleppen das Flugzeug jedes Mal in den Hangar, wenn Sie Einstellungen vornehmen.',
						pt: 'Você reboca a aeronave para dentro do hangar cada vez que realiza ajustes.'
					},
					consequences: {
						text: {
							en: 'Towing the aircraft into the hangar may introduce additional safety risks.',
							de: 'Das Schleppen des Flugzeugs in den Hangar kann zusätzliche Sicherheitsrisiken bergen.',
							pt: 'Rebocar a aeronave para dentro do hangar pode acarretar riscos adicionais de segurança.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 10, value: 1},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C',
					},
					text: {
						en: 'You perform the work while the aircraft is on the apron but take frequent breaks inside to get warm.',
						de: 'Sie führen die Arbeit aus, während sich das Flugzeug auf dem Vorfeld befindet, machen aber häufig Pausen im Inneren, um sich aufzuwärmen.',
						pt: `Você realiza o trabalho enquanto a aeronave está no stand exterior, mas faz pausas frequentes dentro da aeronave para se aquecer.`
					},
					consequences: {
						text: {
							en: 'Despite reducing the negative effect of the environment, there is still pressure to finish the job.',
							de: 'Obwohl die negativen Auswirkungen der Umwelt verringert wurden, besteht weiterhin Druck, die Arbeit zu beenden.',
							pt: `Apesar da redução do impacto negativo no meio ambiente, ainda existe pressão para concluir o trabalho.`
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
			]
		},
		{
			id: 12,
			title: {
				en: 'The original tool',
				de: 'Das Spezialwekzeug',
				pt: 'Ferramenta original'
			},
			text: {
				en: 'You are performing an adjustment and need a special fixture mentioned in the manual. You find that the original tool has never been purchased because of the cost.',
				de: 'Sie führen eine Einstellung durch und benötigen eine spezielle Vorrichtung, die im Handbuch erwähnt wird. Sie stellen fest, dass das Originalwerkzeug aus Kostengründen nie gekauft wurde.',
				pt: `Você está a efetuar um ajuste e precisa de uma ferramenta especial mencionado no manual. Você descobre que a ferramenta original nunca foi comprada devido ao custo.`
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'The neighbor company has an internally approved alternative for the required tool. You copy the tool and use that to complete the job. Then you ask the supervisor to add it to your inventory.',
						de: 'Das Nachbarunternehmen hat eine intern genehmigte Alternative für das benötigte Werkzeug. Sie kopieren das Werkzeug und verwenden es, um die Arbeit zu erledigen. Dann bitten Sie den Vorgesetzten, es zu Ihrem Bestand hinzuzufügen.',
						pt: `A empresa vizinha possui uma alternativa interna aprovada para a ferramenta necessária. Você copia a ferramenta e a utiliza para concluir o trabalho. Em seguida, solicita ao supervisor que a adicione ao seu inventário.`
					},
					consequences: {
						text: {
							en: 'The inadequacy of the tool may go undetected, if you bypass the approval process.',
							de: 'Dass das Werkzeug ungeeignet ist, kann unentdeckt bleiben, wenn Sie das Genehmigungsverfahren umgehen.',
							pt: `A inadequação da ferramenta pode passar despercebida se você ignorar o processo de aprovação.`
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You evaluate the test setup and decide it is perfectly safe to perform the measurements using your standard tools.',
						de: 'Sie bewerten den Versuchsaufbau und entscheiden, dass es absolut sicher ist, die Messungen mit Ihren Standardwerkzeugen durchzuführen.',
						pt: `Você avalia a configuração do teste e decide que é perfeitamente seguro realizar as medições usando suas ferramentas padrão.`
					},
					consequences: {
						text: {
							en: 'If you get the measurements wrong, the integrety of the system is put at risk.',
							de: 'Wenn Sie die Messungen falsch durchführen, ist die Zuverlässigkeit des Systems gefährdet.',
							pt: `Se as medições estiverem incorretas, a integridade do sistema fica comprometida.`
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 5, value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]}, 
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C',
					},
					text: {
						en: 'You complete and sign off the job minus the final adjustment check and defer that check to a new work order after ordering the tool.',
						de: 'Sie beenden und unterschreiben den Auftrag ohne die endgültige Einstellungsprüfung und verschieben diese auf einen neuen Arbeitsauftrag nach der Bestellung des Werkzeugs.',
						pt: `Você conclui e assina o serviço, exceto pela verificação do ajuste final, e transfere essa verificação para uma nova ordem de serviço após encomendar a ferramenta.`
					},
					consequences: {
						text: {
							en: 'There is an increased risk of system failure if the test is not completed.',
							de: 'Es besteht ein erhöhtes Risiko von Systemausfällen, wenn die Prüfung nicht abgeschlossen wird.',
							pt: `Existe um risco maior de falha do sistema se o teste não for concluído.`
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 8, value: 1},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
			]
		},
		{
			id: 13,
			title: {
				en: 'The sealant',
				de: 'Der Sealer',
				pt: `O vedante`
			},
			text: {
				en: 'You need to apply some sealant now in order for it  to cure before the aircraft is needed. It is in stock but you cannot issue it for the task as the computer system is down.',
				de: 'Sie müssen jetzt etwas Sealer auftragen, damit es aushärten kann, bevor das Flugzeug den Hangar verlässt. Im Lager ist es eingelagert, aber Sie können es für die Auftrag nicht ausgeben, da das Computersystem ausgefallen ist.',
				pt: 'Você precisa aplicar um selante agora para que ele cure antes que a aeronave seja necessária. Ele está em stock, mas você não pode disponibilizá-lo para essa tarefa, pois o sistema de computador está sem rede.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You take the sealant and leave a note on the screen asking the next person using the computer to enter your transaction into the system.',
						de: 'Sie nehmen den Sealer und hinterlassen eine Notiz auf dem Bildschirm, in der Sie die nächste Person am Computer bitten, Ihre Transaktion in das System einzugeben.',
						pt: 'Você pega o selante e deixa um recado na tela pedindo para a próxima pessoa que usar o computador registrar a sua transação no sistema.'
					},
					consequences: {
						text: {
							en: 'The note may go unnoticed so the system is not updated.',
							de: 'Der Hinweis könnte unbemerkt bleiben, wodurch das System nicht aktualisiert wird.',
							pt: 'A anotação pode passar despercebida, impedindo a atualização do sistema.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 1, value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You take the sealant with the intention of making the entry the next day.',
						de: 'Sie nehmen den Sealer mit der Absicht, die Buchung am nächsten Tag vorzunehmen.',
						pt: 'Você aplica o selante com a intenção de fazer a entrada de registo no dia seguinte.'
					},
					consequences: {
						text: {
							en: 'The update may not be done, if you get distracted or forget.',
							de: 'Die Buchung wird möglicherweise nicht durchgeführt, wenn Sie abgelenkt werden oder es vergessen.',
							pt: 'A atualização pode não ser concluída se você se distrair ou esquecer.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You contact Operations and tell them the aircraft will be grounded until sealant is available.',
						de: 'Sie setzen sich mit der Betriebsleitung in Verbindung und teilen ihr mit, dass das Flugzeug am Boden bleibt, bis der Sealer verfügbar ist.',
						pt: 'Você entra em contato com a área de Operações e informa que a aeronave ficará em solo até que o selante esteja disponível.'
					},
					consequences: {
						text: {
							en: 'Huge costs may result from delays or cancellations.',
							de: 'Durch Verspätungen oder Absagen können enorme Kosten entstehen.',
							pt: 'Atrasos ou cancelamentos podem acarretar custos enormes.'
						},
						effects: [
							{type: 'cost', value: 2},
							{type: 'dirtyDozen', dirtyDozenId: 7, value: 1},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
			]
		}
	],
	/* Day 3 */
	'day-3': [
		{
			id: 20,
			title: {
				en: 'The scratch',
				de: 'Der Kratzer',
				pt: 'O arranhão'
			},
			text: {
				en: 'You are installing a component when a pilot asks you to have a quick look at her aircraft. She wants to know if a scratch on a side window is within limits.',
				de: 'Sie bauen gerade ein Bauteil ein, als eine Pilotin Sie bittet, sich ihr Flugzeug kurz anzuschauen. Sie möchte wissen, ob ein Kratzer an der Seitenscheibe noch in Ordnung ist.',
				pt: 'Você está instalando um componente quando uma piloto pede para você dar uma olhada rápida na aeronave dela. Ela quer saber se um arranhão numa janela lateral está dentro dos limites aceitáveis.'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You do this 15 minute job straight away.',
						de: 'Sie erledigen diesen 15-minütigen Job sofort.',
						pt: 'Você realiza essa tarefa de 15 minutos imediatamente.'
					},
					consequences: {
						text: {
							en: 'You assume that you can do this quickly, but things may escalate.',
							de: 'Sie gehen davon aus, dass Sie das schnell erledigen können, aber die Dinge könnten schnell ausufern.',
							pt: 'Você presume que pode fazer isso rapidamente, mas as coisas podem se agravar.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 2, value: 1},
							{type: 'time', value: 2, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]}, 
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You ask her to use the formal reporting channels.',
						de: 'Sie bitten die Pilotin, den offiziellen Meldeweg zu benutzen.',
						pt: 'Você pede a ela que utilize os canais formais de reporte de anomalias.'
					},
					consequences: {
						text: {
							en: 'Be aware of how you communicate this: the pilot may feel brushed off.',
							de: 'Achten Sie darauf, wie Sie dies kommunizieren: Die Pilotin könnte sich dadurch abgewiesen fühlen.',
							pt: 'Preste atenção em como você comunica isso: o piloto pode se sentir ignorado.'
						},
						effects: [
							{type: 'dirtyDozen', dirtyDozenId: 6, value: 1},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You tell her that you are busy and that scratches are usually ok, if you cannot feel them with your nails.',
						de: 'Sie sagen ihr, dass Sie beschäftigt sind und dass Kratzer normalerweise in Ordnung sind, wenn man sie nicht mit den Fingernägeln fühlen kann.',
						pt: 'Você diz-lhe que está ocupada e que arranhões geralmente não são problema, desde que você não os sinta com as unhas.'
					},
					consequences: {
						text: {
							en: 'Safety may be compromised if your advice is inaccurate.',
							de: 'Wenn Ihr Rat ungenau ist, besteht die Gefahr, dass die Sicherheit beeinträchtigt wird.',
							pt: 'A segurança pode ser comprometida se o seu conselho for impreciso.'
						},
						effects: [
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
			]
		},
		{
			id: 21,
			title: {
				en: 'The calibration sticker',
				de: 'Die Kalibrierungsplakette',
				pt: 'O adesivo de calibração'
			},
			text: {
				en: 'You are about to use a calibrated tool, when you find that the calibration sticker is missing. You remember using the tool a few days ago and also remember the due date is yet to expire.',
				de: 'Sie wollen ein kalibriertes Werkzeug benutzen, als Sie feststellen, dass die Kalibrierungsplakette fehlt. Sie erinnern sich, dass Sie das Werkzeug vor einigen Tagen benutzt haben und dass das Fälligkeitsdatum noch nicht abgelaufen ist.',
				pt: 'Você está prestes a usar uma ferramenta calibrada quando percebe que o adesivo de calibração está em falta. Você se lembra de ter usado a ferramenta há alguns dias e também se lembra de que a data de validade ainda não expirou.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You use the tool as it is.',
						de: 'Sie verwenden das Werkzeug so, wie es ist.',
						pt: 'Você usa a ferramenta tal como ela está.'
					},
					consequences: {
						text: {
							en: 'There may be a reason why the sticker is removed. Maybe the tool is faulty?',
							de: 'Es könnte einen Grund geben, warum der Aufkleber entfernt wurde. Vielleicht ist das Werkzeug defekt?',
							pt: 'Pode haver um motivo para o adesivo ter sido removido. Talvez a ferramenta esteja com defeito?'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You drive to the other side of the airport to pick up a similar tool in the line station tool box.',
						de: 'Sie fahren auf die andere Seite des Flughafens, um ein ähnliches Werkzeug aus dem Werkzeugkasten der Line Station zu holen.',
						pt: 'Você conduz até o outro lado do aeroporto para pegar uma ferramenta semelhante na caixa de ferramentas da estação de manutenção.'
					},
					consequences: {
						text: {
							en: 'Increased time doing this may cause stress, pressure and delays.',
							de: 'Ein erhöhter Zeitaufwand für diese Tätigkeit kann zu Stress, Druck und Verzögerungen führen.',
							pt: 'O aumento do tempo gasto nessa tarefa pode causar estresse, pressão e atrasos.'
						},
						effects: [
							{type: 'time', value: 2},
							{type: 'dirtyDozen', dirtyDozenId: 4, value: 1},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You consult the calibration database and retrieve the information required for making a new sticker. You mark the tool and use it to finish the job.',
						de: 'Sie konsultieren die Kalibrierungsdatenbank und rufen die für die Erstellung eines neuen Aufklebers erforderlichen Informationen ab. Sie markieren das Werkzeug und verwenden es, um die Arbeit zu beenden.',
						pt: 'Você consulta o banco de dados de calibração e obtém as informações necessárias para fazer um novo adesivo. Você marca a ferramenta e a utiliza para concluir o trabalho.'
					},
					consequences: {
						text: {
							en: 'Increased time doing this may cause stress, pressure and delays.',
							de: 'Ein erhöhter Zeitaufwand für diese Tätigkeit kann zu Stress, Druck und Verzögerungen führen.',
							pt: 'O aumento do tempo gasto nessa tarefa pode causar estresse, pressão e atrasos.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]}, 
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		},
		{
			id: 22,
			title: {
				en: 'The routine job',
				de: 'Die Routinearbeit',
				pt: 'O trabalho rotineiro'
			},
			text: {
				en: 'You are about to perform a routine job. When trying to access the maintenance job instructions, you find that the manual server is down.',
				de: 'Sie sind dabei, eine Routinearbeit durchzuführen. Als Sie versuchen, die Anweisungen für die Wartungsarbeiten aufzurufen, stellen Sie fest, dass der Server für das Handbuch nicht verfügbar ist.',
				pt: 'Você está prestes a executar uma tarefa de rotina. Ao tentar acessar as instruções de manutenção, você descobre que o servidor manual está sem rede.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You have done this job many times. You can safely do it again without consulting the manual.',
						de: 'Sie haben diese Aufgabe schon viele Male erledigt. Sie können sie ohne Bedenken wiederholen, ohne das Handbuch zu Rate zu ziehen.',
						pt: 'Você já realizou essa tarefa muitas vezes. Pode realizá-la novamente com segurança, sem precisar consultar o manual.'
					},
					consequences: {
						text: {
							en: 'Complacency and distractions may cause you to forget details.',
							de: 'Nachlässigkeit und Ablenkungen können dazu führen, dass Sie Details vergessen.',
							pt: 'A complacência e as distrações podem fazer com que você se esqueça de detalhes.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You know that an identical system is installed on another type of aircraft; and those manuals are available. You use them to complete the job.',
						de: 'Sie wissen, dass ein identisches System in einem anderen Flugzeugtyp installiert ist, und dass diese Handbücher verfügbar sind. Sie verwenden sie, um die Arbeit zu erledigen.',
						pt: 'Você sabe que um sistema idêntico está instalado em outro tipo de aeronave; e esses manuais estão disponíveis. Você os utiliza para concluir o trabalho.'
					},
					consequences: {
						text: {
							en: 'Complacency and Lack of knowledge may cause you to believe that the systems are similar when they are in fact, not.',
							de: 'Selbstgefälligkeit und mangelndes Wissen können dazu führen, dass Sie davon ausgehen, dass die Systeme ähnlich sind, obwohl sie es nicht sind.',
							pt: 'A complacência e a falta de conhecimento podem levar você a acreditar que os sistemas são semelhantes quando, na verdade, não são.'
						},
						effects: [
							{type: 'dirtyDozen', dirtyDozenId: 9, value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You ask a neighbor company if you can use their manual.',
						de: 'Sie fragen ein befreundetes Unternehmen, ob Sie dessen Handbuch verwenden können.',
						pt: 'Você pergunta a uma empresa vizinha se pode usar o manual deles.'
					},
					consequences: {
						text: {
							en: 'It will take extra time to obtain the manual and you cannot be sure it is updated.',
							de: 'Es dauert länger, das Handbuch zu beschaffen, und Sie wissen nicht, ob es aktuell ist.',
							pt: 'A obtenção do manual levará mais tempo e você não terá certeza de que ele esteja atualizado.'
						},
						effects: [
							{type: 'time', value: 2},
							{type: 'dirtyDozen', dirtyDozenId: 7, value: 1},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
			]
		},
		{
			id: 23,
			title: {
				en: 'The ladder',
				de: 'Die Leiter',
				pt: 'A escada'
			},
			text: {
				en: 'When fetching a ladder from the equipment storage area, you notice that another ladder has a loose step.',
				de: 'Während Sie eine Leiter aus dem Gerätelager holen, stellen Sie fest, dass eine andere Leiter eine lose Stufe aufweist.',
				pt: 'Ao buscar uma escada na área de armazenamento de equipamentos, você percebe que outra escada tem um degrau solto.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You put a red tag on it, move it to quarantine and report it to your supervisor.',
						de: 'Sie versehen diese mit einem roten Etikett, bringen sie ins Sperrlager und melden sie Ihrem Vorgesetzten.',
						pt: 'Você coloca uma etiqueta vermelha, move para a quarentena e reporta ao seu supervisor.'
					},
					consequences: {
						text: {
							en: 'While this may take longer to do right now, you eliminate a potential hazard.',
							de: 'Das kann zwar länger dauern, aber Sie beseitigen damit eine potenzielle Gefahr.',
							pt: 'Embora isso possa demorar mais agora, você elimina um risco potencial.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You do nothing. You expect your colleagues to check any ladder they want to use.',
						de: 'Sie tun nichts. Sie erwarten von Ihren Kollegen, dass diese die Leitern, die sie benutzen wollen, überprüfen.',
						pt: 'Você não faz nada. Espera que seus colegas verifiquem qualquer escada que queiram usar.'
					},
					consequences: {
						text: {
							en: 'Ignoring latent problems increases the risk of an accident.',
							de: 'Das Ignorieren verborgener Probleme erhöht das Risiko eines Unfalls.',
							pt: 'Ignorar problemas latentes aumenta o risco de acidentes.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You remove the equipment check label so everybody can see that the ladder is broken.',
						de: 'Sie entfernen das Prüfplakat für die Ausrüstung, damit jeder sehen kann, dass die Leiter kaputt ist.',
						pt: 'Você remove a etiqueta de verificação do equipamento para que todos possam ver que a escada está quebrada.'
					},
					consequences: {
						text: {
							en: 'The latent hazard has not been removed and still poses a risk to the safe working environment.',
							de: 'Die Gefahrenquelle wurde nicht beseitigt und stellt nach wie vor ein Risiko für die sichere Arbeitsumgebung dar.',
							pt: 'O risco latente não foi eliminado e ainda representa uma ameaça para a segurança do ambiente de trabalho.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
			]
		}
	],
	/* Day 4 */
	'day-4': [
		{
			id: 25,
			title: {
				en: 'Almost done',
				de: 'Fast fertig',
				pt: 'Quase pronto'
			},
			text: {
				en: 'You and a colleague have performed an inspection; and you shall sign off and release the aircraft. Time is running late, and you have to leave. All testing has been completed and only the reinstallation of panels and cowlings remain.',
				de: 'Sie und ein Kollege haben eine Inspektion durchgeführt; Sie sollen das Flugzeug abzeichnen und freigeben. Die Zeit drängt, und Sie müssen gehen. Alle Tests sind abgeschlossen, und es müssen nur noch die Panels und Cowlings wieder montiert werden.',
				pt: 'Você e um colega realizaram a inspeção e devem assinar o documento de despacho da aeronave. O tempo está se esgotando e vocês precisam ir embora. Todos os testes foram concluídos e resta apenas a reinstalação dos painéis e das carenagens.'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'Your colleague agrees to finish the job. You sign for the inspection in the logbook and work order and leave.',
						de: 'Ihr Kollege erklärt sich bereit, die Arbeit zu beenden. Sie unterschreiben die Inspektion im Logbuch sowie den Arbeitsauftrag und gehen.',
						pt: 'Seu colega concorda em terminar o trabalho. Você assina a inspeção no livro de registro e a ordem de serviço e vai embora.'
					},
					consequences: {
						text: {
							en: 'Errors may go undetected if the aircraft is prematurely released.',
							de: 'Wenn das Flugzeug vorzeitig freigegeben wird, könnten Fehler unentdeckt bleiben.',
							pt: 'Erros podem passar despercebidos se a aeronave for liberada prematuramente.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You ask for somebody else to sign once the job is completely done.',
						de: 'Nachdem die Arbeit vollständig erledigt ist, bitten Sie eine andere Person um eine Unterschrift.',
						pt: 'Você pede para outra pessoa assinar assim que o trabalho estiver completamente concluído.'
					},
					consequences: {
						text: {
							en: 'This is a task handover situation where errors may go undetected if handled informally.',
							de: 'Dies ist eine Übergabe, bei der Fehler unentdeckt bleiben können, wenn sie informell gehandhabt werden.',
							pt: 'Esta é uma situação de transferência de tarefas em que erros podem passar despercebidos se forem tratados informalmente.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You ask your colleague to complete the job and prepare the paperwork. You will sign for the aircraft next morning before first flight.',
						de: 'Sie bitten Ihren Kollegen, den Auftrag auszuführen und die Papiere vorzubereiten. Sie werden für das Flugzeug am nächsten Morgen vor dem ersten Flug unterschreiben.',
						pt: 'Você pede ao seu colega para concluir o trabalho e preparar a documentação. Você assinará o recebimento da aeronave na manhã seguinte, antes do primeiro voo.'
					},
					consequences: {
						text: {
							en: 'The aircraft may end up on the apron without release.',
							de: 'Es könnte sein, dass das Flugzeug ohne Freigabe auf das Vorfeld gelangt.',
							pt: 'A aeronave pode ficar no stand exterior sem ser despachada.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'time', value: 2, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]}, 
							{type: 'time', value: 2, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
						],
					},
				},
			]
		},
		{
			id: 26,
			title: {
				en: 'The late colleague',
				de: 'Der verspätete Kollege',
				pt: 'O colega atrasado'
			},
			text: {
				en: 'You are working on a complex modification that you must hand over at the end of the shift. The colleague taking over is late, and you have to leave.',
				de: 'Sie arbeiten an einer komplexen Modifikation, die Sie am Ende Ihrer Schicht übergeben müssen. Der Kollege, der die Arbeit übernimmt, kommt zu spät, und Sie müssen gehen.',
				pt: 'Você está a trabalhar numa modificação complexa que precisa ser entregue no final do turno. O colega que vai assumir está atrasado e você precisa sair.'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You shoot a video explaining what you have done and the task status. You send it to your colleague.',
						de: 'Sie drehen ein Video, in dem Sie erklären, was Sie getan haben und wie der Stand der Arbeit ist. Sie senden es an Ihren Kollegen.',
						pt: 'Você grava um vídeo explicando o que fez e o status da tarefa. Em seguida, envia o vídeo para seu colega.'
					},
					consequences: {
						text: {
							en: 'You cannot be sure that the colleague watches and understands the video.',
							de: 'Sie können nicht sicher sein, dass der Kollege das Video sieht und versteht.',
							pt: 'Você não pode ter certeza de que o colega assiste e entende o vídeo.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You hand over the task to another person from the next shift and ask him to pass the information on.',
						de: 'Sie übergeben die Aufgabe an eine andere Person der nächsten Schicht und bitten sie, die Informationen weiterzugeben.',
						pt: 'Você passa a tarefa para outra pessoa do próximo turno e pede que ela repasse a informação.'
					},
					consequences: {
						text: {
							en: 'The message may get lost in translation when passed on.',
							de: 'Die Botschaft kann bei der Weitergabe möglicherweise verloren gehen.',
							pt: 'A mensagem pode se perder na tradução ao ser transmitida.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'time', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'Reluctantly you cancel your private arrangements and wait for the colleague to show up.',
						de: 'Widerwillig sagen Sie Ihre privaten Vereinbarungen ab und warten auf den Kollegen.',
						pt: 'Você, a contragosto, cancela seus compromissos particulares e espera que o colega apareça.'
					},
					consequences: {
						text: {
							en: 'You put yourself under more stress and may forget or deviate from procedures.',
							de: 'Sie setzen sich selbst mehr Stress aus und vergessen eventuell Abläufe oder weichen von ihnen ab.',
							pt: 'Você se submete a mais stress e pode se esquecer de procedimentos ou se desviar deles.'
						},
						effects: [
							{type: 'time', value: 2},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]}, 
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
			]
		},
		{
			id: 27,
			title: {
				en: 'The temporary malfunction',
				de: 'Die vorübergehende Störung',
				pt: 'A anomalia temporária'

			},
			text: {
				en: 'A pilot has reported a temporary malfunction of a system.',
				de: 'Ein Pilot hat eine vorübergehende Störung eines Systems gemeldet.',
				pt: 'Um piloto relatou uma falha temporária em um sistema.'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You do 3 consecutive tests, but the system works fine. You release the aircraft with (No Fault Found).',
						de: 'Sie führen 3 aufeinanderfolgende Tests durch, doch das System funktioniert einwandfrei. Sie geben das Flugzeug mit (No Fault Found) frei.',
						pt: 'Você realiza 3 testes consecutivos, mas o sistema funciona bem. Você despacha a aeronave com a mensagem (Nenhuma falha encontrada).'
					},
					consequences: {
						text: {
							en: 'If the system starts to fail more consistently, you may end up with a grounded aircraft.',
							de: 'Wenn das System häufiger ausfällt, kann es sein, dass das Flugzeug gegroundet wird.',
							pt: 'Se o sistema começar a falhar com mais frequência, você poderá acabar com uma aeronave parada no solo.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You cannot repeat the system failure during tests. It is commonly known that a certain component causes trouble. You replace that component and release the aircraft.',
						de: 'Sie können den Systemfehler während der Tests nicht wiederholen. Es ist allgemein bekannt, dass eine bestimmte Komponente Probleme verursacht. Sie ersetzen diese Komponente und geben das Flugzeug frei.',
						pt: 'Não é possível reproduzir a falha do sistema durante os testes. É sabido que determinado componente causa problemas. Esse componente é substituído e a aeronave é despachada.'
					},
					consequences: {
						text: {
							en: 'Your bias towards a preferred type of action may prevent you from seeing other indications pointing to other components.',
							de: 'Ihre Voreingenommenheit für einer bevorzugten Vorgehensweise kann Sie daran hindern, weitere Anzeichen zu erkennen, die auf andere Komponenten hinweisen.',
							pt: 'Sua preferência por um tipo específico de ação pode impedi-lo de perceber outros indícios que apontam para outros componentes.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'cost', value: 2, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You do a full and comprehensive troubleshooting of the entire system and all components.',
						de: 'Sie führen eine vollständige und umfassende Fehlersuche im gesamten System durch.',
						pt: 'Você realiza uma análise completa e abrangente de todo o sistema e de todos os seus componentes.'
					},
					consequences: {
						text: {
							en: 'This may be a very lenghty operation depending on system complexity.',
							de: 'Je nach Komplexität des Systems kann dies ein sehr aufwendiger Vorgang sein.',
							pt: 'Essa operação pode ser bastante demorada, dependendo da complexidade do sistema.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
			]
		},
		{
			id: 28,
			title: {
				en: 'The functional check',
				de: 'Der Functional Check',
				pt: 'O funcional check'
			},
			text: {
				en: 'You are conducting a Functional Check of a system and shall measure the voltage between pins a and b in a plug. Only two wires are installed in the plug, and they are at positions aa and bb.',
				de: 'Sie führen einen Functional Check eines Systems durch und sollen die Spannung zwischen den Stiften a und b in einem Stecker messen. In dem Stecker sind nur zwei Pins installiert, und zwar an den Positionen aa und bb.',
				pt: 'Você está realizando um teste funcional de um sistema e deve medir a tensão entre os pinos a e b de um conector. Apenas dois fios estão instalados no conector, nas posições aa e bb.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'This is obviously a typing error in the manual. You conduct the test replacing a with aa and b with bb.',
						de: 'Dies ist offensichtlich ein Tippfehler in der Anweisung. Sie führen den Test durch, indem Sie a durch aa und b durch bb ersetzen.',
						pt: 'Obviamente, trata-se de um erro de digitação no manual. O teste deve ser realizado substituindo "a" por "aa" e "b" por "bb".'
					},
					consequences: {
						text: {
							en: 'The test you perform may not be designed to identify any existing faults in the system.',
							de: 'Der von Ihnen durchgeführte Test ist möglicherweise nicht darauf ausgelegt, vorhandene Fehler im System zu erkennen.',
							pt: 'O teste que você realizar pode não ter sido projetado para identificar quaisquer falhas existentes no sistema.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You stop the test and ask engineering to contact the aircraft manufacturer for guidance.',
						de: 'Sie brechen die Prüfung ab und bitten das Engineering, den Flugzeughersteller um Rat zu fragen.',
						pt: 'Você interrompe o teste e pede à equipa de engenharia que entre em contacto com o fabricante da aeronave para obter orientações.'
					},
					consequences: {
						text: {
							en: 'This will most likely increase the downtime significantly.',
							de: 'Dies wird die Standzeit höchstwahrscheinlich erheblich verlängern.',
							pt: 'Isso provavelmente aumentará o tempo de inatividade de forma significativa.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You skip the part of the testing procedure that cannot be performed in accordance with the instruction.',
						de: 'Sie überspringen den Teil des Prüfverfahrens, der nicht gemäß der Anweisung durchgeführt werden kann.',
						pt: 'Você ignora a parte do procedimento de teste que não pode ser realizada de acordo com as instruções.'
					},
					consequences: {
						text: {
							en: 'Your maintenance actions are inadequate in detecting all faults that may exist in the system.',
							de: 'Ihre Wartungsmaßnahmen reichen nicht aus, um alle möglichen Fehler im System zu erkennen.',
							pt: 'Suas ações de manutenção são insuficientes para detectar todas as falhas que possam existir no sistema.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
			]
		}
	]
};


export { eventCardsData };
